export default __webpack_public_path__ + "static/media/header-tooltip-icon.39dc5cab.svg";